export const GOOGLE_SEARCH = "GOOGLE_SEARCH";
export const DROPBOX_SEARCH = "DROPBOX_SEARCH";
export const WHATSAPP_SEARCH = "WHATSAPP_SEARCH";
export const EXTENSION_SEARCH = "EXTENSION_SEARCH";
export const DELETE_WHATSAPP_SEARCH_ITEM = "DELETE_WHATSAPP_SEARCH_ITEM";
export const DELETE_DROPBOX_SEARCH_ITEM = "DELETE_DROPBOX_SEARCH_ITEM";
export const DELETE_GOOGLE_SEARCH_ITEM = "DELETE_GOOGLE_SEARCH_ITEM";
export const DELETE_EXTENSION_SEARCH_ITEM = "DELETE_EXTENSION_SEARCH_ITEM";
export const SET_LOADING = "SET_LOADING";
